import {withTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import {Avatar, Button, Fade, IconButton, makeStyles, Modal, Snackbar, Typography} from '@material-ui/core';
import {useDispatch, useSelector} from "react-redux";
import {roundingDown} from "../../../utils/RoundingDown";
import {unlockLp} from '../../../utils/Sign'
import CustomTextField from '../../CommonElements/CustomTextField'
import CloseIcon from "@material-ui/icons/Close";
import {getIcons} from "../../../utils/Common";
import {poolActions} from "../../../redux/actions/poolActions";
const poolPopTopBG = 'https://cdn.swapallapp.com/l2/images/poolPopTopBG.png'
const confirmIcon = 'https://demobanner.api-sands.com/Icons/swapIcon.png'

const Unlock = (props) => {
    const {
        onCancel: handleClose,
        modalVisible,
        values,
        address,
        chainId,
        network,
        web3,
        t
    } = props;
    const [amount1, setAmount1] = React.useState("");
    const [resultViewVisible, setResultViewVisible] = useState(false);
    const [submitDisable, setSubmitDisable] = React.useState(true);
    const [snackBarVisible, setSnackBarVisible] = React.useState(false);
    const [amount1Warning, setAmount1Warning] = React.useState('');
    const useStyles = makeStyles((theme) => ({
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',


        },
        paper: {
            position: 'absolute',
            width: 400,
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
        }
    }));
    const classes = useStyles();
    const { poolSigning, myLiquidityPools,myLocker } = useSelector(state => state.pool)
    const { tokenIcons } = useSelector(state => state.wallet)
    const { token } = useSelector(state => state.auth)
    const dispatch = useDispatch();
    const myPool = myLiquidityPools.find(item => item.poolId === values.pid)
    const mylock = myLocker.find(item => item.id === values.id)
    const coinFree1 = mylock.amount;
    const staked1rate = myPool ? myPool.staked1 / myPool.lpTokenCapital.total : 0
    const staked2rate = myPool ? myPool.staked2 / myPool.lpTokenCapital.total : 0
    useEffect(() => {
        dispatch(poolActions.getMyLiquidityPool(token))
        dispatch(poolActions.getMyLocker(token))
        return () => {
        }
    }, [])

    useEffect(() => {
        if ( amount1 > 0 && coinFree1  && amount1 <= coinFree1) {
            setSubmitDisable(false)
        } else {
            setSubmitDisable(true)
        }
        if (amount1 <= 0 && amount1 != "") {
            setAmount1Warning(t('invalidInput'))
        } else if ((!coinFree1 || amount1 > coinFree1) && amount1 != "") {
            setAmount1Warning(t('insufficient_fund'))
        } else {
            setAmount1Warning("")
        }
        return () => {
        }
    }, [amount1, myLiquidityPools])

    const handleSubmit = async () => {
        setResultViewVisible(true)
        await unlockLp(address, chainId, network, web3, dispatch, poolSigning, values.id, amount1, setAmount1,myPool.token1, myPool.token2, token, handleClose, setSnackBarVisible)
        setResultViewVisible(false)
    }

    const handleChange = (event) => {
        if (event.target.name === "amount1") {
            setAmount1(event.target.value)
        }
    };

    const handleSnackClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackBarVisible(false);
    };

    const resultViewBody = (
        <div style={{
            backgroundColor: '#09135F', borderRadius: 24, width: 480, overflow: 'hidden', outline: 0, display: 'flex', alignItems: 'center', flexDirection: 'column'
        }}>

            <Avatar src={confirmIcon} variant="square" style={{ height: 54*1.2, width: 77*1.2,marginTop:24 }} />

            <Typography style={{ fontSize: 16, fontWeight: 'bold', marginTop: 8, color: 'white' }}>
                {t('pool-confirm-title')}
            </Typography>
            <Typography style={{ fontSize: 12, fontWeight: 'bold', marginTop: -4, color: '#8FB9E1' }}>
                {t('pool-confirm-content')}
            </Typography>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '89%',marginTop:40}}>
                <Typography style={{ fontSize: 14, color: 'white', fontWeight: 'bold' }}>
                    {t('pool-unlock-unlock')}
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography style={{ fontSize: 14, color: 'white', fontWeight: 'bold', marginRight: 8 }} >
                        {amount1 + " " +(myPool?myPool.token1:null)+'-'+ (myPool?myPool.token2:null) +'-LP'}
                    </Typography>
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '89%',marginTop:8 }}>
                <Typography style={{ fontSize: 14, color: 'white', fontWeight: 'bold' }}>
                    {t('price')}
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography style={{ fontSize: 14, color: 'white', fontWeight: 'bold', marginRight: 8 }} >
                        1{myPool?myPool.token1:null} ≈ {myPool ? myPool.staked2 === 0 ? "-" : roundingDown(myPool.staked2 / myPool.staked1, 8) :'-'} {myPool?myPool.token2:null}
                    </Typography>
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '89%',marginTop:8,marginBottom:40 }}>
                <Typography style={{ fontSize: 14, color: 'white', fontWeight: 'bold' }}>
                    {t('pool-unlock-estValue')}
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography style={{ fontSize: 14, color: 'white', fontWeight: 'bold', marginRight: 8 }} >
                        {roundingDown(amount1 * staked1rate,8)} {myPool?myPool.token1:null} + {roundingDown(amount1 * staked2rate,8)} {myPool?myPool.token2:null}
                    </Typography>
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 8, width: '89%' }}>
                <Typography style={{ fontSize: 12, fontWeight: 'bold', color: '#8FB9E1', textAlign: 'center' }}>
                    {t('pool-lock-confirmWarning')}
                </Typography>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 8, width: '89%', marginBottom: 40 }}>
                <Typography style={{ fontSize: 12, fontWeight: 'bold', color: '#8FB9E1', textAlign: 'center' }}>
                    {t('pool-unlock-confirmAnnounce')}
                </Typography>
            </div>

        </div>
    );


    const unlockBody = (
        <div style={{
            backgroundColor: '#09135F', borderRadius: 24, width: 400, alignItems: 'center', overflow: 'hidden', outline: 0
        }}>
            <div style={{ display: 'flex', flexDirection: 'row', position: 'absolute', width: 400, paddingTop: 40, alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ marginLeft: 24 }}>
                    <Typography style={{ fontSize: 16, fontWeight: 'bold', color: '#1ADA9A' }}>{t('pool-unlock-unlock')} LP</Typography>
                    <Typography style={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}>{myPool?myPool.token1 :null}-{myPool? myPool.token2: null}</Typography>

                </div>
                <div style={{ flexDirection: 'row', display: 'flex', backgroundColor: 'white', height: 48, alignItems: 'center', width: 100, justifyContent: 'space-between', borderRadius: 24, marginRight: 24 }}>
                    <Avatar src={getIcons(myPool ? myPool.token1 : null, tokenIcons, true)} style={{ height: 32, width: 32, marginLeft: 12 }} />
                    <Avatar src={getIcons(myPool ? myPool.token2 : null, tokenIcons, true)} style={{ height: 32, width: 32, marginRight: 12 }} />

                </div>
            </div>
            <img src={poolPopTopBG} style={{ width: 400, height: 120, borderTopRightRadius: 24, borderTopLeftRadius: 24, opacity: 0.5 }}>

            </img>

            <div style={{ marginLeft: 24, marginRight: 24, }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
                    <Typography style={{ fontSize: 14, color: 'white', fontWeight: 'bold' }}>
                        {t('pool-myLocker-unlocked')} / {t('pool-myLocker-totalLocked')}
                    </Typography>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Typography style={{ fontSize: 14, color: 'white', fontWeight: 'bold' }} >
                            {roundingDown(mylock.unlockedAmount,8)} / {roundingDown(mylock.amount + mylock.unlockedAmount,8)}
                        </Typography>
                    </div>
                </div>

                <CustomTextField
                    id="amount1"
                    name="amount1"
                    label={
                        coinFree1 ?
                            t('pool-lock-enter') + ' LP ' + t('pool-lock-amount') + "(" + t('pool-lock-balance') + ":" + roundingDown(coinFree1, 4) + " LP)"
                            :
                            t('pool-lock-no') + " LP " +t('pool-lock-balance')
                    }
                    style={{ width: '100%', textTransform: 'none' }}
                    onChange={handleChange}
                    value={amount1}
                    helperText={amount1Warning}
                    error={amount1Warning !== ''}
                    rightbuttonlabel={t('all')}
                    onrightbuttonclick={() => {
                        if (coinFree1) {
                            setAmount1(roundingDown(coinFree1, 8))
                        } else {
                            setAmount1("0")
                        }
                    }}
                    customtype="number"
                >
                </CustomTextField>

            </div>

            <div style={{ marginLeft: 24, marginRight: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16 }}>
                <Typography style={{ fontSize: 12, color: '#8FB9E1', fontWeight: 'bold' }}>
                    {t('pool-unlock-estValue')}
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography style={{ fontSize: 12, color: '#8FB9E1', fontWeight: 'bold',  }} >
                        {roundingDown(amount1 * staked1rate,8)} {myPool ? myPool.token1 : null} + {roundingDown(amount1 * staked2rate,8)} {myPool ? myPool.token2 :null}
                    </Typography>
                </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'flex-end', flexDirection: 'column', marginTop: 40, width: '100%' }}>
                <Button
                    // variant="outlined"
                    onClick={handleSubmit}
                    disabled={submitDisable}
                    style={{ backgroundColor: '#1ADA9A', width: "100%", height: 60, borderRadius: 0 ,opacity:submitDisable ? 0.5:1 }}
                >

                    <Typography style={{ fontSize: 16, fontWeight: 'bold', color: '#010846' }}>

                        {t('pool-unlock-unlock')}
                    </Typography>

                </Button>


            </div>

            {/*确认页*/}
            <Modal
                open={resultViewVisible}
                // open={true}

                onClose={() => {
                    if (!poolSigning) {
                        setResultViewVisible(false)
                    }
                }}
                className={classes.modal}
            >
                {resultViewBody}
            </Modal>
            {/*取消签名提示框*/}
            <Snackbar
                open={snackBarVisible}
                onClose={handleSnackClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                autoHideDuration={5000}
                TransitionComponent={Fade}
                message={t('actionCancelled')}
                key={"cancelSign"}
                action={
                    <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleSnackClose}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            />
        </div >
    );

    return (
        <Modal
            open={modalVisible}
            onClose={() => {
                handleClose()
            }}
            disableEnforceFocus
            className={classes.modal}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"

        >
            {unlockBody}
        </Modal>
    )
}

export default withTranslation()(Unlock);
